import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalContent,
  Text,
  ModalActions,
  Button,
} from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
interface Props {
  paymentName: string
  onClose: () => void
}

export const SwiperOfflineModal = ({ paymentName, onClose }: Props) => {
  const t = useT()
  return (
    <Modal dismissable={false}>
      <ModalHeader>
        {t(`You're offline`, {
          _context: 'Modal header text for payment with swiper',
        })}
      </ModalHeader>
      <ModalContent>
        <Text tag="p">
          <T
            _str={`${paymentName} payments can not be accepted while the register is offline.`}
            paymentName={paymentName}
          />
        </Text>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose}>
          {t('Choose Another Payment Type', { _context: 'Button label' })}
        </Button>
      </ModalActions>
    </Modal>
  )
}
